import React, { Component, Fragment } from "react";
import { Col } from "reactstrap";

import bg_maintenance from "../assets/architect/utils/images/originals/maintenance.jpg";

class Maintenance extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  /*********************************** LIFECYCLE ***********************************/
  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /*********************************** RENDER ***********************************/
  render() {
    return (
      <Fragment>
        <img
          src={bg_maintenance}
          style={{
            position: "absolute",
            top: "0px",
            bottom: "0px",
            right: "0px",
            left: "0px",
            display: "block",
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: "0"
          }}
        />
        <div className="h-100 bg-animation">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ paddingTop: "100px" }}
          >
            <Col md="8" className="mx-auto">
              <div className="w-100 mx-auto">
                <h1>We are improving the Platform</h1>
                <h3>Please be patient. We&rsquo;ll be back soon!</h3>
                <div>
                  <p>
                    Sorry for the inconvenience but we&rsquo;re performing some
                    maintenance at the moment.
                    <br />
                    If you need to you can always{" "}
                    <a href="mailto:yourproject@codify.pt">contact us</a>,
                    otherwise we&rsquo;ll be back online shortly!
                  </p>
                  <p>
                    <a href="http://codify.pt" target="_blank">
                      Codify
                    </a>
                  </p>
                </div>
              </div>
            </Col>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Maintenance;



// WEBPACK FOOTER //
// ./src/Maintenance/Maintenance.js